<template>
  <div>
    <div class="d-flex justify-content-center py-4" v-if="isLoading">
      <loader/>
    </div>
    <notification-message
      message="Parece que aún no recibes correos correos electrónicos"
      v-if="emails=='' && !isLoading"
    />
    <div class="main-content-container container-fluid px-4">
    	<div>
        <div class="page-header row no-gutters py-4" v-if="!isLoading">
          <div class="col">
            <span class="text-uppercase page-subtitle">Correos electrónicos</span>
            <h3 class="page-title">Visión general</h3>
          </div>
          <div class="col d-flex">
            <div class="btn-group btn-group-sm d-inline-flex ml-auto my-auto" role="group" aria-label="Table row actions">
  						<download-csv/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" v-if="emails.length > 0">
            <div class="card card-small mb-4">
              <div class="card-header border-bottom">
                <h6 class="m-0"></h6>
              </div>
              <div class="card-body p-0 pb-3 text-center">
                <table class="table mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th scope="col" class="border-0">Correo electrónico</th>
                      <th scope="col" class="border-0">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) of emails">
                      <td>{{ item['email'] }}</td>
                      <td><i class="fas fa-trash" @click.prevent=""></i></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    	</div>
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/general/NotificationMessage';
	import DownloadCSV from '@/components/dashboard/emails/DownloadCSV.vue';
	export default {
		components: {
      NotificationMessage,
			'download-csv': DownloadCSV
		},

		data() {
			return {
        isLoading: true,
				emails: []
			}
		},

    mounted() {
      this.getEmails();
    },

    methods: {
      async getEmails() {
        const url = `${process.env.VUE_APP_ROOT_API}/newsletter`;
        const response = await fetch(url);
        if(response.status == 200) {
          this.isLoading = false;
          this.emails = await response.json();
        }
      }
    }
	}
</script>